import React from "react";
import classnames from "classnames";

const Label = ({ className, children, ...otherProps }) => {
    return (
        <label className={classnames("block text-sm font-medium text-gray-700 sm:mt-px", className)} {...otherProps}>
            {children}
        </label>
    );
};

export default Label;
